import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { paginateQuery } from '@/lib/paginateSupabase';

export interface GlobalRouteInterest {
  id: string;
  full_name: string | null;
  email: string;
  phone: string | null;
  user_id: string | null;
  program_id: string;
  organization_id: string | null;
  created_at: string;
  program_name: string;
  organization_name: string | null;
}

type RawRow = {
  id: string;
  full_name: string | null;
  email: string;
  phone: string | null;
  user_id: string | null;
  program_id: string;
  organization_id: string | null;
  created_at: string;
  programs: { name: string } | null;
  organizations: { name: string } | null;
};

/**
 * Vista global de interesados ("Estoy Interesado") de todas las rutas.
 * Las políticas de acceso ya limitan lo que cada rol puede leer:
 * super admin ve todo, admin de empresa solo su organización.
 */
export function useRouteInterests() {
  return useQuery({
    queryKey: ['route-interests', 'global'],
    queryFn: async (): Promise<GlobalRouteInterest[]> => {
      const rows = await paginateQuery<RawRow>((from, to) =>
        supabase
          .from('route_interests')
          .select(
            'id, full_name, email, phone, user_id, program_id, organization_id, created_at, programs(name), organizations(name)',
          )
          .range(from, to) as any,
      );

      return rows
        .map(r => ({
          id: r.id,
          full_name: r.full_name,
          email: r.email,
          phone: r.phone ?? null,
          user_id: r.user_id,
          program_id: r.program_id,
          organization_id: r.organization_id,
          created_at: r.created_at,
          program_name: r.programs?.name ?? 'Ruta eliminada',
          organization_name: r.organizations?.name ?? null,
        }))
        .sort((a, b) => b.created_at.localeCompare(a.created_at));
    },
  });
}
